import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import MundVturb from '../icons/MundVturb';
import VturbIcon from '../icons/Vturb';
import { paymentStatus } from '@/utils/paymentMethods';

export default function Vturb() {
  return (
    <IntegrationTable
      integrationKey="vturb"
      title="VTurb"
      main_icon={<MundVturb />}
      icon={<VturbIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
      fixedOptions={{
        active_statuses: [...paymentStatus],
      }}
    />
  );
}
